import React, { useCallback, useEffect, useRef, useState } from "react";
import DefaultLayout from "../../layout/defaultLayout";
import { Box, Chip, Snackbar, Alert } from "@mui/material";
import AIConnectChartContainer from "features/ai-connect/charts-and-table/chartContainer";
import TableContainer from "features/ai-connect/charts-and-table/TableContainer";
import { DatePicker } from "components/DatePicker/index";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLevel,
  updateHotelId,
  updateGroupId,
} from "store/slices/account/accountSlice";
import HotelsFilterMenu from "components/hotelFilterMenu";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import qs from 'query-string';
import PageTitles from "../../components/PageTitles";
import {toggleAIPanel, toggleShowTC, updateSegmentList, updateSelectedSegments} from "store/slices/aiConnect/aiConnect";
import getAIConnectSegments from "features/ai-connect/utils/getAIConnectSegments";
import AIPanel from "features/ai-connect/aiPanel";
import TermsDialog from "features/ai-connect/aiPanel/termsDialog";
import axios from "axios";
import { APP_AI_CONNECT_API_ENDPOINT } from "constants/api_urls";
import { getUserToken } from "utils/functions/userToken";
const tc_version = "version_1";
const AIConnect = () => {
  const token = getUserToken()
  const searchParams = qs.parse(window.location.search)
  const {pathname, search} = useLocation()
  const hotelId = useSelector((state) => state?.account?.hotel_id);
  const {selected_segments, openAIPanel, showTC} = useSelector(state => state?.aiConnect)
    const {
        account_id = "",
        "is_account_writable": isAccountWritable,
    } = useSelector((state) => state?.account?.account || {});
  const {hotelList = [], groupList = [], can_use_groups: showGroups, group_id, level} = useSelector(state => state?.account)
  const hotelButtonRef = useRef(null);
  const [openHotelModal, setOpenHotelModal] = useState(false);
  const [selectedHotelOrGroupType, setSelectedHotelOrGroupType] =
    useState("hotels");
  const scrollContainerRef = useRef(null);
  const [isChartCollapsed, setIsChartCollapsed] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage] = useState("");
  const [toastType] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [,setCurrentAccountId] = useState(account_id);


  const setQueryFilters = useCallback(() => {
        const hotelIds = searchParams?.["hotelid"];
        const groupIds = searchParams?.["groupid"];
        if(hotelIds){
          dispatch(updateLevel("HOTEL"))
          dispatch(updateGroupId([]))
          if(typeof hotelIds === "string"){
            dispatch(updateHotelId([Number(hotelIds)]))
          }else {
            dispatch(updateHotelId(hotelIds.map(h => Number(h))))
          }
        }
  
        if(groupIds){
          dispatch(updateHotelId([]))
          dispatch(updateLevel("GROUP"))
          if(typeof groupIds === "string"){
            dispatch(updateGroupId([Number(groupIds)]))
          }else {
            dispatch(updateGroupId(groupIds.map(h => Number(h))))
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[dispatch,hotelList, level, searchParams])

  useEffect(() => {
     if(account_id && hotelList.length){
       setCurrentAccountId(prev => {
         if(prev !== account_id){
           setQueryFilters();
         }
         return account_id;
       })
     }else{
       setQueryFilters()
     }
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [account_id, dispatch, hotelList, search]);

   useEffect(() => {
       if(!level){
         dispatch(
           updateLevel(selectedHotelOrGroupType === "hotels" ? "HOTEL" : "GROUP")
         );
       }
       setQueryFilters();
         // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [dispatch,search,level]);

  useEffect(() => {
    if(!searchParams?.['segments']){
      if (
        Object.keys(searchParams).length &&
        (searchParams?.hotelid || searchParams?.groupid)
      ) {
        const searchLevel = searchParams?.groupid ? "GROUP" : "HOTEL";
        const hotels =
          typeof searchParams?.hotelid === "string"
            ? [Number(searchParams?.hotelid)]
            : searchParams?.hotelid;
        const groups =
          typeof searchParams?.groupid === "string"
            ? [Number(searchParams?.groupid)]
            : searchParams?.groupid;
        dispatch(
          updateSegmentList(
            getAIConnectSegments(
              searchLevel === "HOTEL" ? hotels || [] : groups || [],
              searchLevel,
              true
            )
          )
        );
      } else {
        dispatch(
          updateSegmentList(
            getAIConnectSegments(level === "HOTEL" ? hotelId : group_id, level, true)
          )
        );
      }
      dispatch(updateSelectedSegments(null));
    } else {
      dispatch(updateSelectedSegments(typeof searchParams?.['segments']=== 'string' ? [searchParams?.['segments']]: searchParams?.['segments']))
    }
    dispatch(toggleAIPanel(false));
    dispatch(toggleShowTC(false));
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch,search,hotelList, level, hotelId, group_id]);

  useEffect(() => {
      if(!searchParams?.['hotelid'] && !searchParams?.['groupid'] && !searchParams?.['segments']){
        dispatch(updateSegmentList(getAIConnectSegments(hotelId, "HOTEL", true)))
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch,search,hotelId])

    useEffect(() => {
      return () => {
        if(!searchParams?.['segments']) {
        dispatch(updateSelectedSegments(null))
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch])

    const handleAgree = () => {
      axios.post(`${APP_AI_CONNECT_API_ENDPOINT}/api/ai-connect/bidding-panel-info/${account_id}/update-t-c/${tc_version}`,{},{
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }).then((response) => {
        if(response?.data?.t_c) {
          dispatch(toggleShowTC(false));
          dispatch(toggleAIPanel(true));
        }
      }).catch(console.error);
    }

  return (
    <Box className="metasearch">
      <DefaultLayout page={"aiConnect"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "18px",
          }}
        >
          <PageTitles pageTitle="AI Connect" pageSubTitle="" />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            <DatePicker />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingInline: 2,
          }}
        >
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#000000",
                  fontWeight: "400",
                  marginTop: "4px",
                }}
              >
                <div
                  onClick={() => {
                    setOpenHotelModal(true);
                  }}
                  ref={hotelButtonRef}
                >
                  <Chip
                    label={
                      level === "HOTEL" ? hotelId.length === 0
                        ? "Hotels"
                        : hotelId.length === hotelList.length
                          ? "All Hotels"
                        : hotelId.length === 1
                        ? hotelList?.find(
                            (hotel) =>
                              hotel.hotel_id === hotelId?.[0]
                          )?.hotel_name
                        : `${hotelId.length} ${
                             "hotels"
                          } selected`: group_id.length === 0 ? "Groups" : group_id.length === groupList.length ? "All Groups" : group_id.length === 1
                          ? groupList?.find(
                              (group) =>
                                group.id === group_id?.[0]
                            )?.name
                          : `${group_id.length} ${
                               "groups"
                            } selected`
                    }
                    sx={{
                      backgroundColor: "inherit",
                      fontFamily: "inter",
                      fontSize: "12px",
                      fontWeight: "400",
                      marginRight: "4px",
                      cursor: "pointer",
                      height: "26px",
                      minWidth: "120px",
                      //border: hotelId.length > 0 ? "1px solid #BAB7B7" : "1px solid grey",
                      border: "1px solid #BAB7B7",
                      ":hover": {
                        cursor: "pointer",
                        border: "1px solid #000000",
                      },
                    }}
                  />
                </div>
                {openHotelModal && (
                  <HotelsFilterMenu
                    allHotels={hotelList?.map((ho) =>
                      hotelId.find((hf) => hf === ho.hotel_id)
                        ? { ...ho, isSelected: true }
                        : { ...ho, isSelected: false }
                    )}
                    allGroups={groupList?.map((ho) =>
                      group_id.includes(ho.id)
                        ? { ...ho, isSelected: true }
                        : { ...ho, isSelected: false }
                    )}
                    showGroups={showGroups}
                    anchorEl={hotelButtonRef.current}
                    open={openHotelModal}
                    isSelectAllRequired
                    onApply={(selected) => {
                      const type = selected?.length ?  selected.filter(s => s?.isSelected).some(s => s?.type === "HOTEL") ? "hotels" : "groups" : selectedHotelOrGroupType;
                      dispatch(
                        updateLevel(type === "hotels" ? "HOTEL" : "GROUP")
                      );
                       if (!selected_segments) {
                         dispatch(
                           updateSegmentList(
                             getAIConnectSegments(
                               selected,
                               type === "hotels" ? "HOTEL" : "GROUP",
                               true
                             )
                           )
                         );
                         dispatch(updateSelectedSegments(null));
                       }
                     if (type === "hotels") {
                       dispatch(
                         updateHotelId(
                           selected.map((item) => item?.["hotel_id"])
                         )
                       );
                       dispatch(updateGroupId([]));
                       delete searchParams?.groupid;
                       navigate(
                         `${pathname}?${createSearchParams({
                           ...searchParams,
                           hotelid: selected?.map((p) => p.hotel_id),
                         })}`
                       );
                     } else {
                       dispatch(
                         updateGroupId(selected.map((item) => item?.["id"]))
                       );
                       dispatch(updateHotelId([]));
                       delete searchParams?.hotelid;
                       navigate(
                         `${pathname}?${createSearchParams({
                           ...searchParams,
                           groupid: selected?.map((p) => p.id),
                         })}`
                       );
                     }
                    }}
                    onClose={() => {
                      setOpenHotelModal(false);
                    }}
                    setSelectedHotelOrGroupType={(type) => {
                      setSelectedHotelOrGroupType(type);
                    }}
                    selectedHotelOrGroupType={level === "HOTEL" ? "hotels" : "groups"}
                  />
                )}
              </div>
            </div>
          </div>
        </Box>
        <Box sx={{}} ref={scrollContainerRef}>
          <div
            style={{
              height: "228px",
              display: isChartCollapsed || openAIPanel ? "none" : "block",
            }}
          >
            <AIConnectChartContainer backgroundColor="transparent" />
          </div>
          {openAIPanel && (
            <div
              style={{
                height: "228px",
                display: openAIPanel ? "block" : "none",
              }}
            >
              <AIPanel />
            </div>
          )}
          <TableContainer
            hotelList={hotelList}
            isAccountWritable={isAccountWritable}
            isChartCollapsed={isChartCollapsed}
            setIsChartCollapsed={setIsChartCollapsed}
            onEditClick={() => {
              dispatch(toggleAIPanel(!openAIPanel));
            }}
          />
        </Box>{" "}
      </DefaultLayout>
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showToast}
        autoHideDuration={3000}
        onClose={() => {
          setShowToast(false);
        }}
      >
        <Alert severity={toastType} variant="filled" sx={{ width: "100%" }}>
          {toastMessage}
        </Alert>
      </Snackbar>
      {showTC && openAIPanel && (
        <TermsDialog
          open={showTC}
          onClose={() => {
            dispatch(toggleShowTC(false));
            dispatch(toggleAIPanel(false));
          }}
          onAgree={handleAgree}
        />
      )}
    </Box>
  );
};
export default AIConnect;
